import React from 'react'

import bkgImage from '../../Assets/Student.png'

import Navbar from '../../Components/Navbar/Navbar';
import Hero from '../../Components/Hero/Hero';
import Footer from '../../Components/Footer/Footer';
import Dashboard from '../../Components/Dashboard/Dashboard';

import { StudentNavItems } from './StudentNavItems';
import { STUDENT_USER_TYPE } from '../../services/UserService';

const StudentDashboard = () => {
    return (
        <div className="flex flex-col min-h-screen">
            <Navbar navItems={StudentNavItems} user={STUDENT_USER_TYPE} />
            <Dashboard user={STUDENT_USER_TYPE} />
            <Footer user={STUDENT_USER_TYPE} />
        </div>
    )
};

export default StudentDashboard;